import { useState, useCallback } from "react";
import { InvoiceData } from "../../../../../types/invoices";

interface InvoiceModalsState {
  showViewModal: boolean;
  setShowViewModal: (show: boolean) => void;
  showDeleteConfirm: boolean;
  setShowDeleteConfirm: (show: boolean) => void;
  revisionPreviewId: string | null;
  setRevisionPreviewId: (id: string | null) => void;
  handleViewRevision: (revision: InvoiceData) => void;
  handlePrintRevision: (revision: InvoiceData) => void;
}

const useInvoiceModals = (): InvoiceModalsState => {
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [revisionPreviewId, setRevisionPreviewId] = useState<string | null>(
    null
  );

  const handleViewRevision = useCallback((revision: InvoiceData): void => {
    if (revision.id) {
      setRevisionPreviewId(revision.id);
    }
  }, []);

  // Print-specific behaviour (e.g. auto-trigger browser print dialog once the
  // revision preview loads) is deferred to a follow-up. See AB#2089613.
  const handlePrintRevision = useCallback((revision: InvoiceData): void => {
    if (revision.id) {
      setRevisionPreviewId(revision.id);
    }
  }, []);

  return {
    showViewModal,
    setShowViewModal,
    showDeleteConfirm,
    setShowDeleteConfirm,
    revisionPreviewId,
    setRevisionPreviewId,
    handleViewRevision,
    handlePrintRevision
  };
};

export default useInvoiceModals;
